export default __webpack_public_path__ + "static/media/default_bg.3c72b1ba.png";